import { io, Socket } from 'socket.io-client'

let _socket: Socket | null = null

export const initSocket = (userId?: string): Socket => {
	if (_socket) {
		_socket.disconnect()
	}

	_socket = io(process.env.REACT_APP_SOCKET_URL as string, {
		transports: ['websocket'],
		withCredentials: true
	})

	_socket.on('connect', () => {
		console.log('Connected to socket.io server')
		if (userId) {
			_socket!.emit('join', { userId })
		}
	})

	_socket.on('disconnect', () => {
		console.log('Disconnected from socket.io server')
	})

	return _socket
}

export const getSocket = (): Socket | null => _socket
